import { z } from 'zod';

import { CommonBookingRequestSchema } from './booking';
import { makeEndpoint } from '../common';

// TODO: Maybe find a better way to share all the types
export const MinimalBookingForPaymentIntentSchema = CommonBookingRequestSchema.extend({
  experienceId: z.string(),
  resourceGroupId: z.string().optional(),
  resourceQuantity: z.number().optional(),
});

/** Why the client sent a payment intent request; logged by the API for diagnosing request loops. */
export enum PaymentIntentRequestTrigger {
  CART_CHANGED = 'cart_changed',
  INITIAL = 'initial',
  LOCAL_CHANGE = 'local_change',
  REFRESH = 'refresh',
  SYNCED_CHANGE = 'synced_change',
}

export const CreatePaymentIntentRequestSchema = z.object({
  // Plain strings, not enums: diagnostics must never fail request validation.
  clientContext: z
    .object({
      sessionId: z.string(),
      trigger: z.string(),
    })
    .optional(),
  data: z.array(MinimalBookingForPaymentIntentSchema),
  getOnlyTotalNetAmount: z.boolean().optional(),
  paymentIntentRevision: z.number().optional(),
});

const CreatePaymentIntentResponseSchema = z.object({
  totalNetAmount: z.number(),
  paymentIntentSecret: z.string().nullable(),
});

export type PaymentIntent = z.output<typeof CreatePaymentIntentResponseSchema>;

export const CreatePaymentIntentEndpoint = makeEndpoint({
  method: 'POST',
  url: ({ brandId, cartId }: { brandId: string; cartId: string }) => `/v1/brands/${brandId}/carts/${cartId}/payment_intents`,
  requestSchema: CreatePaymentIntentRequestSchema,
  responseSchema: CreatePaymentIntentResponseSchema,
});

export enum CartErrorMessage {
  NOT_REUSABLE = 'Cart is not reusable',
  ALREADY_USED_IN_BOOKING = 'Cart id already used in a booking',
}

export const DiscardCartEndpoint = makeEndpoint({
  url: ({ brandId, cartId }: { brandId: string; cartId: string }) => `/v1/brands/${brandId}/carts/${cartId}/discard`,
  method: 'POST',
  requestSchema: z.void(),
  responseSchema: z.void(),
});
